import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {IMenuStore} from "../../mobx-store/storeInterfaces/menuStoreInterface";
import {TableCellTypes} from "../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes";
import {RouteComponentProps} from "react-router";
import GeneralTableComponent from "../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent";

interface IProps extends RouteComponentProps {
    menuStore: IMenuStore;
}


@inject('menuStore')
@observer
class CategoriesScreen extends Component<IProps> {
    addButton: any;
    tableHeader: any = [];
    tableData: any[] = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string;

    constructor(props: IProps) {
        super(props);
        this.title = 'Manage Categories';
    }

    handleTableButtonCellClicked = (index: string, key: string) => {
        this.props.history.push(`/categories/${index}/${key}`);
    };

    handelAdd = (): void => {
        this.props.history.push('/categories/new');
    };

    getAddAdButton = () => {
        return {
            title: 'Add Category',
            onAdd: this.handelAdd,
        };
    };

    getAdsTableHeader = () => {
        return [
            {
                title: 'Category Name',
            },
            {
                title: 'Category Image',
            },
            {
                title: 'Brands',
            },
            {
                title: 'Edit',
            }
        ];
    };


    getAdsTableCellTypes = (): TableCellTypes[] => {
        return [
            {
                cellType: 'Text',
                key: 'categoryName',
            },
            {
                cellType: 'Image',
                key: 'categoryImage',
            },
            {
                cellType: 'Text',
                key: 'brandsString',
            },
            {
                cellType: 'Button',
                key: 'edit',
                onClick: this.handleTableButtonCellClicked
            }
        ];
    };

    componentDidMount(): void {
        this.props.menuStore.mapCategoriesItemsBrands();
    }

    render() {
        const {loaded, categories: oCategories, brands: oBrands, items: oItems} = this.props.menuStore;
        if (loaded) {
            const categoriesItemsBrands = oCategories.map(cat => {
                const brands = cat.brands.map(brandInCat => {
                    const brand = oBrands.filter(b => b.brandId === brandInCat);
                    return brand ? brand[0] : undefined;
                }).filter(b => b !== undefined);
                const brandsString = brands.map(b => b ? b.brandName: '').join(', ');
                const items = oItems.filter(i => i.categoryId === cat.categoryId).map(i => ({
                    ...i, edit: 'Edit', delete: 'Delete', id: i.itemId
                }));
                return {
                    ...cat,
                    mappedBrands: brands,
                    items,
                    edit: 'Edit',
                    delete: 'Delete',
                    id: cat.categoryId,
                    brandsString
                }
            });
            this.addButton = this.getAddAdButton();
            this.tableHeader = this.getAdsTableHeader();
            this.tableData = categoriesItemsBrands;
            this.tableCellTypes = this.getAdsTableCellTypes();
            return loaded && (
                <div>
                    <GeneralTableComponent emptyMessage='There are no categories added yet'
                                           title={this.title}
                                           tableHeader={this.tableHeader}
                                           tableData={this.tableData}
                                           tableCellTypes={this.tableCellTypes}
                                           addButton={this.addButton}/>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default CategoriesScreen;

